<template>
  <div class="page">
    <h2 style="margin-bottom:15px;text-align:center;">{{invoice.partnerName}}</h2>
    <div style="padding-left:350px;padding-right:350px;height:100px;">{{invoice.partner.address}}</div>
    <div style="padding-left:350px;">
      <span style="width:50px;display:inline-block;text-align:left;">Tel:</span>
      <span style="width:120px;display:inline-block;text-align:left;">{{invoice.partner.tel}}</span>
    </div>
    <div style="padding-left:350px;">
      <span style="width:50px;display:inline-block;text-align:left;">Fax:</span>
      <span style="width:120px;display:inline-block;text-align:left;">{{invoice.partner.fax}}</span>
    </div>
    <div
      style="position:absolute; top:200px; right:40px;"
    >PAGE: {{invoice.pageIndex}} / {{invoice.total.value}}</div>
    <div style="text-align:center;margin-top:15px;">
      <h1 style="border-bottom:1px solid #000;line-height:30px;display:inline-block;">PACKING LIST</h1>
    </div>
    <div style="width:100%;text-align:right;">
      <span
        style="display:inline-block;width:120px;text-align:right;padding-right:15px;"
      >INVOICE NO:</span>
      <span style="display:inline-block;width:120px;text-align:left;">{{invoice.invoiceNo}}</span>
    </div>
    <div style="width:100%;text-align:right;">
      <span
        style="display:inline-block;width:120px;text-align:right;padding-right:15px;"
      >INVOICE DATE:</span>
      <span style="display:inline-block;width:120px;text-align:left;">{{invoice.creationDate}}</span>
    </div>
    <table class="contract-info">
      <tr>
        <td style="width:5%;">SOLD TO :</td>
        <td style="width:45%;">
          SHARP CORPORATION
          <br>1.TAKUMI-CHO,SAKAI-KU, SAKAI-SHI,
          <br>OSAKA 590-8522, JAPAN
        </td>
        <td style="width:5%;">SHIP TO :</td>
        <td style="width:45%;">
          SHARP CORPORATION
          <br>1.TAKUMI-CHO,SAKAI-KU, SAKAI-SHI,
          <br>OSAKA 590-8522, JAPAN
        </td>
      </tr>
      <tr>
        <td>TEL :</td>
        <td>(81)50-5433-4138</td>
        <td>TEL :</td>
        <td>(81)50-5433-4138</td>
      </tr>
      <tr>
        <td>FAX :</td>
        <td>(81)72-222-5724</td>
        <td>FAX :</td>
        <td>(81)72-222-5724</td>
      </tr>
      <tr>
        <td>ATTN :</td>
        <td></td>
        <td>ATTN :</td>
        <td></td>
      </tr>
      <tr>
        <td>FROM :</td>
        <td>{{invoice.loadingPortName}}</td>
        <td colspan="2">SHIPPING MARK :</td>
      </tr>
      <tr>
        <td>TO :</td>
        <td>{{invoice.dischargePortName}}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td colspan="2">SHIPPING METHOD :{{invoice.transportModeCode}}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>ETD :</td>
        <td>{{invoice.etd}}</td>
        <td></td>
        <td></td>
      </tr>
    </table>

    <div class="list" style="margin-top:50px;">
      <div class="row" style="height:80px;border-top:1px solid #000;border-bottom:1px solid #000;">
        <div style="left:0px;top:5px;">C/NO.</div>
        <div style="left:100px;top:5px;">INTERNAL NAME</div>
        <div style="left:100px;top:25px;">EXTERNAL NAME</div>
        <div style="left:100px;top:45px;">P/O No.</div>
        <div style="left:300px;top:5px;width:100px;text-align:right;">QUANTITY</div>
        <div style="left:300px;top:25px;width:100px;text-align:right;">QTY/GTN</div>
        <div style="left:300px;top:45px;">DESCRIPTION OF GOODS</div>
        <div style="right:200px;top:5px;">N/W</div>
        <div style="right:100px;top:5px;">G/W</div>
        <div style="right:0px;top:5px;">M3</div>
      </div>
      <div
        :key="item.id"
        class="row"
        style="height:80px;border-bottom:1px solid #000;"
        v-for="item in invoice.packages"
      >
        <div style="left:0px;top:5px;">
          {{item.cartonStartNo}} - {{item.cartonEndNo}}
          <br>
          ({{cartonQty(item)}})
        </div>
        <div style="left:100px;top:5px;">{{item.skuCode}}</div>
        <div style="left:100px;top:25px;">{{item.skuCode}}</div>
        <div style="left:100px;top:45px;">{{item.poNo}}</div>
        <div
          style="left:250px;top:5px;width:150px;text-align:right;"
        >{{item.totalQty|currency({fractionCount:2})}}</div>
        <div style="left:405px;top:5px;text-align:right;">(PC)</div>
        <div
          style="left:250px;top:25px;width:150px;text-align:right;"
        >{{item.perCartonQty|currency({fractionCount:2})}}</div>
        <div style="left:300px;top:45px;">{{item.productName}}</div>
        <div style="right:200px;top:5px;">{{netWeight(item)|currency({fractionCount:2})}}</div>
        <div style="right:100px;top:5px;">{{grossWeight(item)|currency({fractionCount:2})}}</div>
        <div style="right:0px;top:5px;">{{volume(item)|currency({fractionCount:4})}}</div>
      </div>
      <div class="row" style="height:20px;" v-if="invoice.pageIndex===invoice.total.value">
        <div style="left:0px;top:5px;">TOTAL:</div>
        <div
          style="left:100px;top:5px;width:100px;text-align:right;"
        >{{invoice.totalCartonQty|currency({fractionCount:0})}} CTN(S)</div>
        <div
          style="left:250px;top:5px;width:150px;text-align:right;"
        >{{invoice.totalQty|currency({fractionCount:2})}}</div>
        <div style="left:405px;top:5px;text-align:right;">(PC)</div>
        <div style="right:200px;top:5px;">{{invoice.totalNetWeight|currency({fractionCount:2})}}</div>
        <div style="right:100px;top:5px;">{{invoice.totalGrossWeight|currency({fractionCount:2})}}</div>
        <div style="right:0px;top:5px;">{{invoice.totalVolume|currency({fractionCount:4})}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['invoice'],
  methods: {
    cartonQty(pkg) {
      return pkg.cartonEndNo - pkg.cartonStartNo + 1
    },
    netWeight(pkg) {
      return this.cartonQty(pkg) * pkg.netWeight
    },
    grossWeight(pkg) {
      return this.cartonQty(pkg) * pkg.grossWeight
    },
    volume(pkg) {
      return this.cartonQty(pkg) * pkg.volume
    }
  }
}
</script>
<style scoped>
.page {
  padding: 30px 30px;
}
.contract-info {
  width: 100%;
}
.contract-info td {
  vertical-align: top;
  word-wrap: normal !important;
  padding: 5px 3px;
}
.list {
  width: 100%;
}
.row {
  width: 100%;
  position: relative;
}
.row > div {
  position: absolute;
}
</style>